import theme from "app/Theme/Theme";
import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

const RemoveIcon = ({
  width = 21,
  height = 22,
  color = "#007EFC",
  backgroundColor = theme.colors["neutral.white"],
}) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 21 22"
      preserveAspectRatio="xMidYMin meet"
    >
      <Circle cx="10.5984" cy="10.7793" r="10.314" fill={backgroundColor} />
      <Path
        d="M7.22168 7.40283L13.9748 14.1559M13.9748 7.40283L7.22168 14.1559L13.9748 7.40283Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default RemoveIcon;
